export default __webpack_public_path__ + "static/media/Poppins-Light.6f5b7a1c.woff";